import { Directive, ElementRef, Input, OnInit, inject } from "@angular/core";
import { Utilities } from "@tylertech/shared-module";
import { PropertyMetadata } from "@tylertech/tyler-api-types";

@Directive({ selector: "[focusOnLoad]" })
export class FocusOnLoadDirective implements OnInit
{
    private hostElement = inject(ElementRef);

    @Input() readonly forCellEdit: boolean;
    @Input() readonly propertyMetadata: PropertyMetadata;

    ngOnInit()
    {
        const self = this;
        const shouldFocus = this.forCellEdit;
        if (!shouldFocus)
            return;

        requestAnimationFrame(()=>
        {
            if (this.focusableInput(this.propertyMetadata?.InputType))
                self.hostElement.nativeElement?.focus();
            else
                self.hostElement.nativeElement?.select();
        });
    }

    private focusableInput(inputType: string): boolean
    {
        return inputType === "Check" || inputType === "Button" || inputType === "Color"
            || inputType === "Select" || inputType === "TypeAhead"
            || Utilities.IsNullOrUndefinedOrEmpty(inputType);
    }
}
